import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';

export default function PaymentRequest(props) {
  const { showPR, setShowPR, accountList, formErrors, setFormErrors, paymentRequestData, setPaymentRequestData, isEdit } = props;

  return (
    <div className="mt-3 col-12">
      <div className="col-12 d-flex align-items-center mb-2">
        <span className="caption-bold mb-0 pe-4">Make an Additional Payment Request</span>
        <label className="switch">
          <input
            type="checkbox"
            checked={showPR || (isEdit && paymentRequestData?.payment_request_number)}
            disabled={isEdit}
            onChange={(e) => {
              setShowPR(e.target.checked);
              if (!e.target.checked) {
                setFormErrors((preVal) => ({ ...preVal, pr_amount: '', pr_due_date: '', pr_deposit_Info: '' }));
              }
            }}
          />
          <span className="slider round"></span>
        </label>
      </div>
      {Boolean(showPR || (isEdit && paymentRequestData?.payment_request_number)) && (
        <div className="card-bg p-3 align-self-start">
          <div className="d-flex flex-wrap gap-md-5 gap-2">
            {paymentRequestData?.payment_request_number && (
              <div className="d-flex align-items-center">
                <div className="p-medium me-2">ID: {paymentRequestData?.payment_request_number}</div>
              </div>
            )}

            {/* Amount */}
            <div className="d-flex align-items-start">
              <div className="p-medium me-2 pt-2">
                Amount
                <span className="text-danger">*</span>
              </div>
              <div className="d-flex flex-column">
                <InputNumber
                  className="input-shadow"
                  placeholder="0"
                  value={paymentRequestData?.amount}
                  onValueChange={(e) => {
                    setPaymentRequestData((preVal) => ({ ...preVal, amount: e.value }));
                    setFormErrors((preVal) => ({ ...preVal, pr_amount: '' }));
                  }}
                  mode="currency"
                  currency="USD"
                  locale="en-US"
                  min={1}
                  disabled={isEdit}
                  style={{ maxWidth: 200 }}
                />
                {formErrors?.pr_amount && <span className="text-danger small mt-1">Required</span>}
              </div>
            </div>

            {/* Due Date */}
            <div className="d-flex align-items-start">
              <div className="p-medium me-2 pt-2">
                Due Date
                <span className="text-danger">*</span>
              </div>
              <div className="d-flex flex-column">
                <Calendar
                  className="input-shadow input-height w-100"
                  placeholder="Due Date"
                  value={paymentRequestData?.dueDate}
                  disabled={isEdit}
                  onChange={(e) => {
                    setPaymentRequestData((preVal) => ({ ...preVal, dueDate: e.value }));
                    setFormErrors((preVal) => ({ ...preVal, pr_due_date: '' }));
                  }}
                />
                {formErrors?.pr_due_date && <span className="text-danger small mt-1">Required</span>}
              </div>
            </div>

            {/* Deposit Info */}
            <div className="d-flex align-items-start">
              <div className="p-medium me-2 pt-2">
                Deposit Info
                <span className="text-danger">*</span>
              </div>
              <div className="d-flex flex-column">
                <Dropdown
                  options={accountList || []}
                  optionLabel="account_name"
                  optionValue="account_id"
                  disabled={isEdit}
                  className="input-shadow"
                  placeholder="Deposit Info"
                  value={paymentRequestData?.depositInfo}
                  onChange={(e) => {
                    setPaymentRequestData((preVal) => ({ ...preVal, depositInfo: e.value }));
                    setFormErrors((preVal) => ({ ...preVal, pr_deposit_Info: '' }));
                  }}
                />
                {formErrors?.pr_deposit_Info && <span className="text-danger small mt-1">Required</span>}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
